import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import moment from 'moment';
import { getFormattedPhoneNumber } from 'src/utils/util';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import {
    AccountDetailsGridContainer,
    AccountDetailsGrid,
    AccountDetailsFont,
    AccountDetailsTitleAddress,
    FavoriteIconMobileContainer,
    AccountDetailsFontMultiline,
    FavoriteIconDesktopContainer,
    AccountDetailFirstCardFont,
    AccountDetailsTitle,
    OrderDetailTabBodyContainer,
    OrderDetailTabBody,
    SalesStructureHeader,
    TextBold,
    AccountDetailsFontHead,
    AccountDetailsPhoneFont,
    BottomNavigation,
    SaaStyledDiv,
    StyledDiv,
} from './AccountDetails.styled';
import { useTranslation } from 'react-i18next';
import Edit from 'src/assets/images/Edit.svg';
import AccountDetailEdit from './AccountDetailEdit';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import OrderDetails from 'src/pages/orders/components/orderDetails/OrderDetails';
import {
    setCommonCancel,
    setIsEdit,
    setPopupCloseFromHeader,
} from 'src/pages/more/redux/actions/index.js';
import { getRefinedFilters } from 'src/pages/home/redux/actions';
import { getProcedureInfoRequest } from 'src/pages/reportUsage/redux/action/actionCreators';
import ReportProcedureData from 'src/pages/orders/components/orderDetails/ReportProcedureData/ReportProcedureData';
import {
    getOrderSummaryData,
    setOrderSummaryModalState,
    closeOrderSummaryModalState,
} from 'src/pages/orders/redux/actions';
import {
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import { getDisplayDate } from 'src/utils/dateUtils';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const AccountDetailCard = ({
    accountDet,
    carrierPickup,
    setCarrierPickup,
    templateNote,
    setTemplateNote,
    carrierOptions,
    selectedCarrier,
    setSelectedCarrier,
    // selectedOption,
    // setSelectedOption,
    onSave,
    handleChange,
    employeeRole,
    templateNotesPopup,
    setTemplateNotesPopup,
}) => {
    //  const [isEdit, setisEdit] = useState(false);
    const { t } = useTranslation();
    const [showOrderDetail, setShowOrderDetail] = useState(false);
    const [procedureInfoData, setProcedureInfoData] = useState({});

    const dispatch = useDispatch();
    const isEdit = useSelector((state) => state.accountReducer.isEdit);
    const winWidth = window.innerWidth;
    const isMobileView = winWidth <= sizes.mobileDevice;
    const { showReportProcedureModal } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const procedureInfoDetails = useSelector(
        (state) => state.reportUsageRootReducer.procedureInfoDetails
    );
    const summaryLoading = useSelector(
        (state) => state.orderSummaryReducer.loading
    );
    useEffectWithErrorLogging(() => {
        if (procedureInfoDetails) {
            setProcedureInfoData({
                ...procedureInfoData,
                ...procedureInfoDetails,
            });
        }
    }, [procedureInfoDetails]);
    const handleClose = () => {
        dispatch(setCommonCancel(false));
        dispatch(setIsEdit(true));
    };

    // const getDetails = () => {
    //     dispatch(getAccountDetailss({ accountId: selectedAccount.accountId }));
    // };
    // const accountUpdate = useSelector(
    //     (state) => state.accountReducer.accountUpdate
    // );
    // useEffectWithErrorLogging(() => {
    //     accountUpdate.statusCode === '200' &&
    //         dispatch(
    //             getAccountDetailss({ accountId: selectedAccount.accountId })
    //         );
    // }, [accountUpdate]);

    const onCancel = () => {
        dispatch(setPopupCloseFromHeader(false));
        dispatch(setCommonCancel(true));
        dispatch(setIsEdit(false));
        setCarrierPickup(carrierPickup === 'Yes' ? 'No' : 'Yes');
    };

    const openOrderDetail = (myCaseRef) => {
        dispatch(getOrderSummaryData());
        dispatch(getRefinedFilters({ filterParam: 'all' }));
        dispatch(getProcedureInfoRequest());

        dispatch(
            setOrderSummaryModalState({
                myCaseRef: myCaseRef,
                orderSummaryModal: true,
            })
        );
        setShowOrderDetail(true);
    };
    const closeCardPreviewHandler = () => {
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
        setShowOrderDetail(false);
    };
    // const handleClick = () => {
    //     dispatch(setIsEdit(false));
    //     onSave();
    // };

    // const accountInfo = useSelector(
    //     (state) => state.accountReducer.accountDetails.accountDetails
    // );
    //console.log('accountInfo' + JSON.stringify(accountInfo));
    const phoneNum = `tel:${accountDet && accountDet.phone}`;
    return (
        <>
            <OrderDetailTabBodyContainer>
                <OrderDetailTabBody>
                    {accountDet && accountDet.salesStructureAssigns && (
                        <AccountDetailsGridContainer
                            container
                            justifyContent={'space-between'}
                            direction="row"
                        >
                            <AccountDetailsGrid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                mobile={12}
                            >
                                {accountDet &&
                                    accountDet.salesStructureAssigns && (
                                        <>
                                            <SalesStructureHeader isDemi>
                                                {t(
                                                    'accounts.accountDetailCard.salesStructureAssignments'
                                                )}
                                            </SalesStructureHeader>
                                            {accountDet &&
                                                accountDet.salesStructureAssigns.map(
                                                    (item) => {
                                                        return (
                                                            <>
                                                                <SaaStyledDiv>
                                                                    <AccountDetailsFontHead
                                                                        mbMarginTop={
                                                                            '12px !important'
                                                                        }
                                                                        isRegular
                                                                    >
                                                                        {
                                                                            item.salesOrgId
                                                                        }
                                                                        {'.'}
                                                                        {
                                                                            item.salesForceId
                                                                        }
                                                                        {'.'}
                                                                        {
                                                                            item.salesHierarchyId
                                                                        }
                                                                    </AccountDetailsFontHead>
                                                                    <AccountDetailFirstCardFont
                                                                        isDemi
                                                                    >
                                                                        {
                                                                            item.level3Desc
                                                                        }{' '}
                                                                        {
                                                                            '  •  '
                                                                        }{' '}
                                                                        <AccountDetailFirstCardFont
                                                                            isRegular
                                                                            style={{
                                                                                marginBottom:
                                                                                    '10px',
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.level5Desc
                                                                            }
                                                                            {/* {'/'}
                                                            {item.salesForceId} */}
                                                                        </AccountDetailFirstCardFont>
                                                                        <br />
                                                                    </AccountDetailFirstCardFont>
                                                                </SaaStyledDiv>
                                                            </>
                                                        );
                                                    }
                                                )}
                                        </>
                                    )}
                            </AccountDetailsGrid>
                        </AccountDetailsGridContainer>
                    )}
                </OrderDetailTabBody>
                <OrderDetailTabBody>
                    <AccountDetailsGridContainer
                        container
                        justifyContent={'space-between'}
                        direction="row"
                    >
                        <AccountDetailsGrid
                            paddingBottom={'0px'}
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                            mobile={12}
                        >
                            {accountDet && accountDet.address && (
                                <>
                                    <AccountDetailsTitle
                                        isDemi
                                        deskmarginTop={'0px'}
                                        deskmarginBottom={'3px'}
                                    >
                                        {t(
                                            'accounts.accountDetailCard.address'
                                        )}
                                    </AccountDetailsTitle>
                                    {accountDet && accountDet.address && (
                                        <AccountDetailsFontMultiline
                                            id="more-accountDetail-address-pii"
                                            isRegular
                                            mbMarginTop={'10px'}
                                        >
                                            {accountDet.address.line1} <br></br>
                                            {accountDet.address.line2 ? (
                                                <>
                                                    {accountDet.address.line2}
                                                    <br></br>
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {accountDet.address.town}
                                            {', '}
                                            {accountDet.address.region
                                                ? accountDet.address.region +
                                                  ' '
                                                : ''}
                                            {accountDet.address.postal}
                                        </AccountDetailsFontMultiline>
                                    )}
                                </>
                            )}
                            {accountDet && accountDet.phone && (
                                <>
                                    <AccountDetailsTitle
                                        isDemi
                                        deskmarginTop={'18px'}
                                        mbMarginTop={'16px'}
                                    >
                                        {t('accounts.accountDetailCard.phone')}
                                    </AccountDetailsTitle>
                                    <AccountDetailsPhoneFont id="more-accountDetail-phone-pii">
                                        {isMobileView ? (
                                            <a
                                                style={{
                                                    textDecoration: 'none',
                                                }}
                                                href={phoneNum}
                                            >
                                                {' '}
                                                {accountDet &&
                                                    getFormattedPhoneNumber(
                                                        accountDet.phone
                                                    )}
                                            </a>
                                        ) : (
                                            <div>
                                                {accountDet &&
                                                    getFormattedPhoneNumber(
                                                        accountDet.phone
                                                    )}
                                            </div>
                                        )}

                                        {/* */}
                                    </AccountDetailsPhoneFont>
                                </>
                            )}
                            {accountDet && accountDet.fax && (
                                <>
                                    <AccountDetailsTitle
                                        isDemi
                                        deskmarginTop={'18px'}
                                        mbMarginTop={'16px'}
                                    >
                                        {t('accounts.accountDetailCard.fax')}
                                    </AccountDetailsTitle>
                                    <AccountDetailsFont id="more-accountDetail-fax-pii" isRegular>
                                        {accountDet &&
                                            getFormattedPhoneNumber(
                                                accountDet.fax
                                            )}
                                    </AccountDetailsFont>
                                </>
                            )}
                            {accountDet && accountDet.recentOrderSstRef && (
                                <>
                                    <AccountDetailsTitle
                                        isDemi
                                        mbMarginTop={'16px'}
                                        deskmarginTop={'18px'}
                                        deskmarginBottom={'3px'}
                                    >
                                        {t(
                                            'accounts.accountDetailCard.mostRecentOrder'
                                        )}
                                    </AccountDetailsTitle>
                                    <AccountDetailsFont
                                        isRegular
                                        marginBottom={'0px'}
                                        mbMarginBottom={'0px'}
                                        mbMarginTop={'10px'}
                                    >
                                        <StyledDiv>
                                            {/* {accountDet && accountDet.recentOrderDate}
                            <span> </span> | <span> </span> */}
                                            {getDisplayDate(
                                                accountDet &&
                                                    accountDet.recentOrderDate
                                            )}
                                            {/* {accountDet && accountDet.recentOrderDate} */}
                                            {/* <span> </span> | <span> </span> */}
                                            &nbsp; | &nbsp;
                                            <div
                                                style={{
                                                    color: '#1010EB',
                                                    cursor: 'pointer',
                                                    fontFamily:
                                                        'AvenirNextWorld Demi',
                                                }}
                                                onClick={() =>
                                                    openOrderDetail(
                                                        accountDet.recentOrderSstRef
                                                    )
                                                }
                                            >
                                                {accountDet &&
                                                    accountDet.recentOrderSstRef}
                                            </div>
                                        </StyledDiv>
                                    </AccountDetailsFont>
                                </>
                            )}
                        </AccountDetailsGrid>
                        <AccountDetailsGrid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                            mobile={12}
                            paddingTop={'0px'}
                        >
                            {accountDet && accountDet.freight && (
                                <>
                                    <AccountDetailsTitle isDemi>
                                        {t(
                                            'accounts.accountDetailCard.freight'
                                        )}
                                    </AccountDetailsTitle>
                                    <AccountDetailsFont isRegular>
                                        {accountDet && accountDet.freight}
                                    </AccountDetailsFont>
                                </>
                            )}
                            {accountDet && accountDet.paymentTerms && (
                                <>
                                    <AccountDetailsTitle
                                        isDemi
                                        deskmarginTop={'0px'}
                                        mbMarginTop={'16px'}
                                        deskmarginBottom={'1px'}
                                    >
                                        {t(
                                            'accounts.accountDetailCard.paymentTerms'
                                        )}
                                    </AccountDetailsTitle>
                                    <AccountDetailsFont
                                        isRegular
                                        mbMarginBottom={'0px'}
                                        mbMarginTop={'10px'}
                                    >
                                        {(accountDet &&
                                            accountDet?.paymentTerms
                                                ?.tissueAccount) ||
                                        accountDet?.paymentTerms
                                            ?.nonTissueAccount ? (
                                            <div>
                                                {accountDet &&
                                                accountDet?.paymentTerms
                                                    ?.nonTissuePayment
                                                    ? `${accountDet.paymentTerms.nonTissuePayment} - ${accountDet.paymentTerms.nonTissueAccount}`
                                                    : ''}
                                                <br />
                                                {accountDet &&
                                                accountDet?.paymentTerms
                                                    ?.tissuePayment
                                                    ? `${accountDet.paymentTerms.tissuePayment} - ${accountDet.paymentTerms.tissueAccount}`
                                                    : ''}
                                            </div>
                                        ) : (
                                            <div>
                                                {accountDet &&
                                                    accountDet.paymentTerms
                                                        ?.nonTissuePayment}
                                                <br />
                                            </div>
                                        )}
                                    </AccountDetailsFont>
                                </>
                            )}
                            {(accountDet?.defaultShipMethods?.nonTissueAccount ||
                                accountDet?.defaultShipMethods?.tissueAccount ||
                                accountDet?.defaultShipMethods
                                    ?.nonTissueShipMethod) && (
                                <>
                                    <AccountDetailsTitle
                                        isDemi
                                        deskmarginTop={'18px'}
                                        mbMarginTop={'16px'}
                                        deskmarginBottom={'3px'}
                                    >
                                        {t(
                                            'accounts.accountDetailCard.defaultShipMethod'
                                        )}
                                    </AccountDetailsTitle>

                                    <AccountDetailsFontMultiline
                                        isRegular
                                        mbMarginTop={'10px'}
                                    >
                                        {(accountDet &&
                                            accountDet?.defaultShipMethods
                                                ?.nonTissueAccount) ||
                                        accountDet?.defaultShipMethods
                                            ?.tissueAccount ? (
                                            <div>
                                                {accountDet &&
                                                accountDet?.defaultShipMethods
                                                    ?.nonTissueShipMethod
                                                    ? `${accountDet?.defaultShipMethods?.nonTissueShipMethod} - ${accountDet?.defaultShipMethods?.nonTissueAccount}`
                                                    : null}
                                                <br />
                                                {accountDet &&
                                                accountDet?.defaultShipMethods
                                                    ?.tissueShipMethod
                                                    ? `${accountDet?.defaultShipMethods.tissueShipMethod} - ${accountDet?.defaultShipMethods?.tissueAccount}`
                                                    : null}
                                            </div>
                                        ) : (
                                            <div>
                                                {' '}
                                                {accountDet &&
                                                    accountDet
                                                        ?.defaultShipMethods
                                                        ?.nonTissueShipMethod}
                                                <br />
                                            </div>
                                        )}
                                    </AccountDetailsFontMultiline>
                                </>
                            )}
                            {accountDet && accountDet.sterileProcessLeadTime && (
                                <>
                                    <AccountDetailsTitle
                                        isDemi
                                        deskmarginTop={'18px'}
                                        mbMarginTop={'16px'}
                                    >
                                        {t(
                                            'accounts.accountDetailCard.sterileProcessLeadTime'
                                        )}
                                    </AccountDetailsTitle>
                                    <AccountDetailsFont
                                        isRegular
                                        marginBottom={'0px'}
                                        mbMarginTop={'10px'}
                                    >
                                        {accountDet &&
                                            accountDet.sterileProcessLeadTime}
                                    </AccountDetailsFont>
                                </>
                            )}
                        </AccountDetailsGrid>
                    </AccountDetailsGridContainer>
                </OrderDetailTabBody>
                <OrderDetailTabBody>
                    {isEdit ? (
                        <AccountDetailEdit
                            // selectedOption={selectedOption}
                            // setSelectedOption={setSelectedOption}
                            carrierPickup={carrierPickup}
                            setCarrierPickup={setCarrierPickup}
                            templateNote={templateNote}
                            setTemplateNote={setTemplateNote}
                            accountDet={accountDet}
                            carrierOptions={carrierOptions}
                            selectedCarrier={selectedCarrier}
                            setSelectedCarrier={setSelectedCarrier}
                            handleChange={handleChange}
                            templateNotesPopup={templateNotesPopup}
                            setTemplateNotesPopup={setTemplateNotesPopup}
                        />
                    ) : (
                        <AccountDetailsGridContainer
                            container
                            justifyContent={'space-between'}
                            direction="row"
                        >
                            <AccountDetailsGrid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                lg={6}
                                xl={6}
                                mobile={11}
                                style={{ marginTop: '0' }}
                                mbPadding={'1rem 1rem 0rem 1rem'}
                            >
                                <AccountDetailsTitle
                                    isDemi
                                    style={{
                                        display: 'inline-flex',
                                        marginTop: '0px',
                                        width: '100%',
                                        justifyContent: 'space-between',
                                    }}
                                    deskmarginTop={'0px'}
                                >
                                    <span style={{ marginBottom: '-15px' }}>
                                        {t(
                                            'accounts.accountDetailCard.carrier'
                                        )}
                                    </span>

                                    {employeeRole !== FIM_USER_ROLE &&
                                        employeeRole !== ITA_USER_ROLE &&
                                        employeeRole !== FIA_USER_ROLE && (
                                            <FavoriteIconMobileContainer>
                                                <img
                                                    style={{
                                                        padding: '2px',
                                                        border: '1px solid #EBEBEB',
                                                        borderRadius: '6px',
                                                        opacity: '1px',
                                                        top: '1251px',
                                                        left: '327px',
                                                        width: '30px',
                                                        height: '30px',
                                                        background:
                                                            '#ffffff 0% 0% no-repeat padding-box',
                                                    }}
                                                    src={Edit}
                                                    alt="edit-button"
                                                    onClick={handleClose}
                                                />
                                            </FavoriteIconMobileContainer>
                                        )}
                                </AccountDetailsTitle>
                                {/* <AccountDetailsFont marginTop={'0px'} isRegular>
                                {accountDet &&
                                    accountDet.carriers &&
                                    accountDet.carriers.map((item) => {
                                        item.label;
                                    })}
                            </AccountDetailsFont> */}
                                <AccountDetailsFont
                                    isRegular
                                    mbMarginTop={'5px'}
                                    mbMarginBottom={'0px'}
                                >
                                    {accountDet &&
                                        accountDet.carrierLabelDisplay}
                                </AccountDetailsFont>
                                <AccountDetailsTitle
                                    isDemi
                                    mbMarginTop={'1rem'}
                                >
                                    {t(
                                        'accounts.accountDetailCard.carrierPickupNotifications'
                                    )}
                                </AccountDetailsTitle>
                                <AccountDetailsFont
                                    isRegular
                                    marginBottom={'0px'}
                                    mbMarginTop={'5px'}
                                    mbMarginBottom={'0px'}
                                >
                                    {accountDet &&
                                        accountDet.carrierPickupNotifications}
                                </AccountDetailsFont>
                            </AccountDetailsGrid>
                            <AccountDetailsGrid
                                item
                                xs={12}
                                sm={5}
                                md={5}
                                lg={5}
                                xl={5}
                                mobile={12}
                                style={{ marginTop: '0' }}
                                paddingBottom
                            >
                                <AccountDetailsTitleAddress isDemi>
                                    {t(
                                        'accounts.accountDetailCard.carrierNotes'
                                    )}
                                </AccountDetailsTitleAddress>
                                <AccountDetailsFontMultiline isRegular>
                                    {accountDet && accountDet.carrierNotes}
                                </AccountDetailsFontMultiline>
                            </AccountDetailsGrid>
                            {employeeRole !== FIM_USER_ROLE &&
                                employeeRole !== ITA_USER_ROLE &&
                                employeeRole !== FIA_USER_ROLE && (
                                    <AccountDetailsGrid
                                        item
                                        xs={1}
                                        sm={1}
                                        md={1}
                                        lg={1}
                                        xl={1}
                                        mobile={1}
                                        mbPadding={'1rem 1rem 0.5rem 1rem'}
                                    >
                                        <FavoriteIconDesktopContainer>
                                            <img
                                                //style={{ padding: '1px 1px 1px 5px' }}
                                                style={{
                                                    padding: '2px',
                                                    border: '1px solid #EBEBEB',
                                                    borderRadius: '6px',
                                                    opacity: '1px',
                                                    top: '1251px',
                                                    left: '327px',
                                                    width: '30px',
                                                    height: '30px',
                                                    boxShadow:
                                                        '0px 0px 2px #00000029',
                                                    background:
                                                        '#ffffff 0% 0% no-repeat padding-box',
                                                    cursor: 'pointer',
                                                }}
                                                src={Edit}
                                                alt="edit-button"
                                                onClick={handleClose}
                                            />
                                        </FavoriteIconDesktopContainer>
                                    </AccountDetailsGrid>
                                )}
                        </AccountDetailsGridContainer>
                    )}
                </OrderDetailTabBody>

                {showOrderDetail && (
                    <OrderDetails
                        showOrderListDetails={showOrderDetail}
                        orderListDetailsClose={closeCardPreviewHandler}
                        fromCalendar={true}
                        fromListScreen={false}
                    />
                )}
                {summaryLoading ? (
                    <Backdrop
                        showCloseButton={false}
                        showBackdrop={true}
                        isModal
                        loaderBackground
                    >
                        <Spinner
                            id="more-accountDetailCard-accountDetailCard-summaryLoadingSpinner"
                            animation="border"
                            variant="primary"
                            small
                        ></Spinner>
                    </Backdrop>
                ) : (
                    <></>
                )}
                {showReportProcedureModal ? (
                    <ReportProcedureData
                        showReportProcedureModal={showReportProcedureModal}
                        procedureInfoData={procedureInfoData}
                        setProcedureInfoData={setProcedureInfoData}
                    />
                ) : null}
            </OrderDetailTabBodyContainer>
            {isEdit ? (
                <>
                    <BottomNavigation>
                        <Button
                            id={'accounts-accountdetails-cancelButton'}
                            show={true}
                            // secondary={true}
                            variant={ButtonStyles?.secondary}
                            border={'1px solid #140F4B'}
                            color={'#140F4B'}
                            width={'131px'}
                            mobileWidth={'160px'}
                            height={'38px'}
                            margin={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '0px 6px 0px 0px'
                                    : '0px 20px 0px 0px'
                            }
                            clicked={onCancel}
                        >
                            <TextBold color={'#140F4B'}>
                                {t('accounts.accountDetailCard.cancel')}
                            </TextBold>
                        </Button>

                        <Button
                        id={'accounts-accountdetails-saveButton'}
                            show={true}
                            // primary={true}
                            variant={ButtonStyles?.primary}
                            width={'131px'}
                            mobileWidth={'160px'}
                            height={'38px'}
                            clicked={onSave}
                        >
                            <TextBold color={'#FFFFFF'}>
                                {t('accounts.accountDetailCard.save')}
                            </TextBold>
                        </Button>
                    </BottomNavigation>
                </>
            ) : null}
        </>
    );
};
export default AccountDetailCard;
